import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const hasTour: TComputedPropMapper<boolean> = ({ offer: { isNewbuildingTourAvailable } }) =>
  Boolean(isNewbuildingTourAvailable);
